"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _RequestStatusTypeFilters = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypeFilters"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _requestSelectors = require("./requestSelectors");

var fetchTwoFactorRequiredEnforcement = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.fetchTwoFactorRequiredEnforcement,
  initiatingActionType: _actions.TwoFactorAuthActionTypes.FETCH_TWO_FACTOR_REQUIRED_ENFORCEMENT,
  requestStatusSelector: _requestSelectors.getFetchTwoFactorRequiredEnforcementRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_ONCE,
  requestActions: _actions.FetchTwoFactorRequiredEnforcement
}));
var setTwoFactorNotRequired = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.setTwoFactorNotRequired,
  initiatingActionType: _actions.TwoFactorAuthActionTypes.SET_TWO_FACTOR_NOT_REQUIRED,
  requestStatusSelector: _requestSelectors.getSetTwoFactorNotRequiredRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_MULTIPLE,
  requestActions: _actions.SetTwoFactorNotRequired
}));
var setTwoFactorRequired = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.setTwoFactorRequired,
  initiatingActionType: _actions.TwoFactorAuthActionTypes.SET_TWO_FACTOR_REQUIRED,
  requestStatusSelector: _requestSelectors.getSetTwoFactorRequiredRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_MULTIPLE,
  requestActions: _actions.SetTwoFactorRequired
}));

var _default = (0, _reduxObservable.combineEpics)(fetchTwoFactorRequiredEnforcement, setTwoFactorNotRequired, setTwoFactorRequired);

exports.default = _default;
module.exports = exports.default;